module.exports = __webpack_public_path__ + "img/pin_exchange_green.a1fc8044.svg";